import { CampaignThemeContextType, DataBoostTheme, DataPackageTheme } from "@phonero/common-ux"
import { CodewordType } from "@phonero/common-graphql/types"

const themes: CampaignThemeContextType = [
  {
    name: "",
  } as DataBoostTheme,
  //Theme name MUST BE the theme value returned by the api!!
  {
    name: "christmas",
    color: "primary",
    band: undefined,
    icon: "/campaign/icon/juleboost_big_light.svg",
    iconCheckoutPage: "/campaign/icon/juleboost_big_dark.svg",
    iconTopping: "/campaign/icon/christmas.svg",
    dataPackageRowIcon: undefined,
    iconImgAlt: "God jul",
    iconSmall: "/campaign/icon/databoostLitenNisselue.svg",
    iconLarge: "/campaign/icon/databoostNisselue.svg",
    ingress:
      "Her er en liten julegave til deg som er Phonerokunde! Husk å ta den i bruk i løpet av jula.",
    type: CodewordType.Extraboost,
  } as DataBoostTheme,
  {
    name: "Easter",
    color: "summer",
    band: undefined,
    icon: "/campaign/icon/easter.svg",
    dataPackageRowIcon: undefined,
    iconImgAlt: "God påske",
    iconSmall: "/campaign/icon/easterLiten.svg",
    iconLarge: "/campaign/icon/easter.svg",
    ingress:
      "Her er en liten påskegave til deg som er Phonerokunde! Husk å ta den i bruk i løpet av påsken.",
    type: CodewordType.Extraboost,
  } as DataBoostTheme,
  {
    name: "Feriesurf",
    actionButtonIcon: "/campaign/icon/actionButton_summer.svg",
    icon: "/campaign/icon/feriesurf_big.svg",
    iconCheckoutPage: "/campaign/icon/feriesurf_big_summary.svg",
    iconImgAlt: "Sommerkampanje",
    color: "summer",
    ingress:
      "Her er en liten sommergave til deg som er Phonerokunde! Husk å ta den i bruk i løpet av juli.",
    description:
      "Som takk for at du er Phonerokunde gir vi deg 1 GB ekstra data helt gratis. Perfekt for sommerens små digitale øyeblikk. Sjekk kart, strøm en podcast eller last opp feriebilder når du har litt ekstra tid.\n\n&nbsp;\n\nVi ønsker deg en fantastisk sommer!",
    type: CodewordType.Extradataeea,
    orderButtonText: "Fyll på med Feriesurf",
  } as DataPackageTheme,
  {
    name: "Summer",
    actionButtonIcon: "/campaign/icon/actionButton_summer.svg",
    icon: "/campaign/icon/sommersurf_big.svg",
    iconCheckoutPage: "/campaign/icon/sommersurf_big_summary.svg",
    iconImgAlt: "Sommerkampanje",
    color: "summer",
    priceLabel: "tilbudspris",
    ingress:
      "Bekymringsfri sommerferie med nok mobildata. Nå får du 50 GB ekstra data til sterkt rabattert pris – og med varighet ut august.",
    description:
      "Gjør deg klar for en bekymringsfri sommer uten å tenke på Wi-Fi. Nå får du hele 50 GB ekstra mobildata til en sterkt rabattert pris – eksklusivt for sommersesongen. Perfekt for late stranddager, hyttetur eller bilturer.\n\n&nbsp;\n\nKjøp pakken nå og bruk dataen når det passer. Den varer ut august og gir deg full frihet i ferien.",
    type: CodewordType.Extradataeea,
  } as DataPackageTheme,  
  {
    name: "summer",
    color: "summer",
    band: undefined,
    icon: "/campaign/icon/feriesurf_big_summary.svg",
    iconCheckoutPage: "/campaign/icon/feriesurf_big_summary.svg",
    iconTopping: undefined,
    dataPackageRowIcon: undefined,
    iconImgAlt: "God sommer",
    iconSmall: undefined,
    iconLarge: undefined,
    ingress:
      "Her er en liten sommergave til deg som er Phonerokunde! Husk å ta den i bruk i løpet av sommeren.",
    type: CodewordType.Extraboost,
  } as DataBoostTheme,
  {
    name: "DittPhonero",
    actionButtonIcon: undefined,
    icon: "/campaign/icon/10GbFree_light.svg",
    iconCheckoutPage: "/campaign/icon/10GbFree_dark.svg",
    iconImgAlt: "DataBonus",
    color: "primary",
    colorOnFree: "tertiary",
    priceLabel: undefined,
    ingress:
      "Psst. Hvem sier vel nei til 10 GB ekstra data? Ikke du vel? Husk å aktivere senest 30. april 2023.",
    description:
      "Hei. Så gøy at du har valg Phonero! Vi vil gjerne starte kundeforholdet med å gi deg 10 GB ekstra data. Du kan aktivere nå - eller når du har behov for ekstra data, senest 30. april 2023. \n\n&nbsp;\n\n Velkommen til oss!",
    type: CodewordType.Extradataeea,
    orderButtonText: "Fyll på gratis data",
  } as DataPackageTheme,
  {
    name: "Verisure25",
    actionButtonIcon: undefined,
    icon: "/campaign/icon/verisure.svg",
    iconImgAlt: "Verisure",
    color: "primary",
    colorOnFree: "tertiary",
    priceLabel: undefined,
    ingress:
      "Verisure, Norge ledende alarmselskap og vår samarbeidspartner, spanderer 25 GB data på alle som ønsker en uforpliktende sikkerhetsbefaring av sitt hjem",
    description:
      "Hei! Så gøy at du er interessert i sikkerhetstjenestene til vår samarbeidspartner Verisure, Norges ledende alarmselskap. Verisure spanderer 25 GB data på alle som gjennomfører en uforpliktende sikkerhetsbefaring. Etter at du har fylt på gratis data vil vi sende ditt mobilnr, navn og postnr til Verisure som tar kontakt for å avtale tid og sted for befaring. Ekstrapakken aktiveres med en gang og varer ut inneværende måned pluss tre måneder.",
    type: CodewordType.Extradataeea,
    orderButtonText: "Fyll på gratis data fra Verisure",
  } as DataPackageTheme,
  {
    name: "Verisure50",
    actionButtonIcon: undefined,
    icon: "/campaign/icon/verisure.svg",
    iconImgAlt: "Verisure",
    color: "primary",
    colorOnFree: "tertiary",
    priceLabel: undefined,
    ingress:
      "Verisure, Norge ledende alarmselskap og vår samarbeidspartner, spanderer 50 GB data på alle som ønsker en uforpliktende sikkerhetsbefaring av sitt hjem",
    description:
      "Hei! Så gøy at du er interessert i sikkerhetstjenestene til vår samarbeidspartner Verisure, Norges ledende alarmselskap. Verisure spanderer 50 GB data på alle som gjennomfører en uforpliktende sikkerhetsbefaring. Etter at du har fylt på gratis data vil vi sende ditt mobilnr, navn og postnr til Verisure som tar kontakt for å avtale tid og sted for befaring. Ekstrapakken aktiveres med en gang og varer ut inneværende måned pluss tre måneder.",
    type: CodewordType.Extradataeea,
    orderButtonText: "Book befaring og få gratis data",
  } as DataPackageTheme,
]

export const getTheme = <T extends DataBoostTheme | DataPackageTheme>(
  theme?: string | null,
  type?: CodewordType
) => {
  return (
    !theme
      ? themes[0]
      : themes.find((t) => t.name.toLowerCase() === theme.toLowerCase() && (!type || t.type === type)) ??
        themes[0]
  ) as T
}

export default themes
